import { createApp } from 'vue'
// TypeScript error? Run VSCode command
// TypeScript: Select TypeScript version - > Use Workspace Version
import App from './App.vue'
import router from './router'
import letsDialAPI from './services/letsDialAPI/plugin'
import axios from 'axios'
import './index.css'
import { createPinia } from 'pinia'
import { abilitiesPlugin } from '@casl/vue'
import LDIcon from '/@/components/ui/LDIcon.vue'
import ability from '/@/services/Ability'
import LetsDialSocketPlugin from './services/letsDialSocket/LetsDialSocketPlugin'
import LetsDialPhonePlugin from './services/letsDialPhone/LetsDialPhonePlugin'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fab } from '@fortawesome/free-brands-svg-icons'
// @ts-expect-error: Intentional ignore
import VTooltip from 'v-tooltip'
import { plugin, defaultConfig } from '@formkit/vue'
import formkitConfig from './formkit.config'
// import 'virtual:vite-plugin-sentry/sentry-config'
import LDInput from './components/ui/form/LDInput.vue'
import VueDraggableGrid from '@noction/vue-draggable-grid'
import '@noction/vue-draggable-grid/styles'
import { initSentry } from './sentry'
// import GridLayout from 'vue3-drr-grid-layout'
// import 'vue3-drr-grid-layout/dist/style.css'

const app = createApp(App)
initSentry(app, router)
library.add(fas as any)
library.add(fab as any)

app.component('FontAwesomeIcon', FontAwesomeIcon)
app.component('LdIcon', LDIcon)
app.component('LDInput', LDInput)
app.use(LetsDialSocketPlugin)
app.use(LetsDialPhonePlugin)
app.use(VTooltip)
// if (
//   import.meta.env.VITE_SENTRY_DSN &&
//   typeof import.meta.env.VITE_SENTRY_DSN === 'string' &&
//   import.meta.env.VITE_DOMAIN &&
//   typeof import.meta.env.VITE_DOMAIN === 'string'
// ) {
//   Sentry.init({
//     app,
//     dsn: import.meta.env.VITE_SENTRY_DSN,
//     trackComponents: true,
//     environment: `${import.meta.env.VITE_ENVIRONMENT}`,
//     dist: import.meta.env.VITE_PLUGIN_SENTRY_CONFIG.dist,
//     release: import.meta.env.VITE_PLUGIN_SENTRY_CONFIG.release,
//     integrations: [
//       new Integrations.BrowserTracing({
//         routingInstrumentation: Sentry.vueRouterInstrumentation(router),
//         tracingOrigins: ['localhost', '*.letsdial.co.za', import.meta.env.VITE_DOMAIN, /^\//],
//       }),
//     ],
//     initialScope: {
//       tags: {
//         client: `${import.meta.env.VITE_CLIENT}`,
//         client_domain: `${import.meta.env.VITE_DOMAIN}`,
//       },
//     },
//     tracesSampleRate: parseFloat(
//       typeof import.meta.env.VITE_SENTRY_SAMPLE_RATE === 'string'
//         ? import.meta.env.VITE_SENTRY_SAMPLE_RATE
//         : '1.0',
//     ),
//   })
// }

app
  .use(router)
  .use(letsDialAPI, axios)
  .use(VueDraggableGrid)
  .use(createPinia())
  .use(plugin, defaultConfig(formkitConfig))
  .use(abilitiesPlugin, ability, {
    useGlobalProperties: true,
  })
  .mount('#app')

export default app
